import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'

@Component({
  selector: 'app-filter-option',
  standalone: true,
  imports: [NgClass],
  templateUrl: './filter-option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterOptionComponent {
  public readonly label = input.required<string>()
  public readonly selected = input(false)
  public readonly disabled = input(false)
  public readonly selectedChange = output<void>()

  /**
   * Handles the select event.
   */
  public onSelect(): void {
    if (this.disabled()) return
    this.selectedChange.emit()
  }
}
